import { getCanvasState } from '@components/ArtBoard/Canvas/helpers/canvas'

import { getRandomPositionWithOffset } from './offset'

const centerElement = (
  x: number,
  y: number,
  elementsList: string[]
): { x: number; y: number } => {
  const elem = document.querySelector('.Tree-root') as HTMLElement
  const ref = elem?.parentElement?.parentElement

  if (!ref) {
    return { x, y }
  }

  const { scale, translate } = getCanvasState(ref)

  if (x === 0 && y === 0) {
    const rect = elem.getBoundingClientRect()
    const tx = translate[0] / scale
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const left = windowWidth / 2 - tx - windowWidth
    const rectTop = -rect.top / scale
    x = left + windowWidth / 2 - 132 / 2
    y = rectTop + windowHeight / scale / 2 - 144 / 2
  }

  const getPosition = (pos: string): number => parseFloat(pos.split('px')[0])

  elementsList.forEach((element) => {
    const elements = document.querySelectorAll(
      element
    ) as NodeListOf<HTMLElement>

    if (elements.length > 0) {
      elements.forEach((item) => {
        const transform = item.style.transform
          .split('translate(')[1]
          ?.split(')')[0]
        const [xPos, yPos] = transform?.split(', ') || [0, 0]

        const rect = item.getBoundingClientRect()
        const itemX = getPosition(xPos)
        const itemY = getPosition(yPos)
        const itemWidth = rect.width / scale
        const itemHeight = rect.height / scale

        if (
          itemX < x + rect.width &&
          itemX + itemWidth > x &&
          itemY < y + rect.height &&
          itemY + itemHeight > y
        ) {
          const pos = getRandomPositionWithOffset([x, y, itemWidth, itemHeight])
          const newOffset = centerElement(pos.x, pos.y, elementsList)
          x = newOffset.x || 0
          y = newOffset.y || 0
        }
      })
    }
  })

  return { x, y }
}

export default centerElement
